var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "ordersSplitListView contentHeight flex-start-start",
      class: { "order-open": _vm.UrlService.includes("client-orders.current") },
    },
    [
      _c("audio", { attrs: { src: "dist/assets/notify.wav" } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "leftside--ordersList pos-sticky h-100 overflow-y" },
        [
          _c("div", { staticClass: "bannerTop w-100 pos-absolute zindex-0" }, [
            _c(
              "div",
              {
                staticClass: "w-100 h-100 bg-grey3 pos-relative",
                class: {
                  "bg-black":
                    _vm.ShopService.shop && _vm.ShopService.shop.Image,
                },
              },
              [
                _vm.ShopService.shop && _vm.ShopService.shop.Image
                  ? _c("img", {
                      staticClass: "img-fit pos-relative w-100 h-100",
                      attrs: {
                        src: _vm.UrlService.imagePath(
                          _vm.ShopService.shop.ShopId,
                          _vm.ShopService.shop.Image
                        ),
                        alt: _vm.ShopService.shop.DefaultName,
                      },
                      on: {
                        error: function ($event) {
                          $event.target.src = "dist/assets/no-img.png"
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  staticClass: "gradient-shadow top-0 pos-absolute w-100 h-100",
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "orders--filters--content pos-relative flex-center-center w-100",
            },
            [
              _c(
                "div",
                { staticClass: "orders--filters w-100" },
                [
                  _c("orders-filter", {
                    attrs: {
                      orders: _vm.orders,
                      "orders-filter": _vm.ordersFilter,
                      loading: _vm.loading,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "orderLists--content container p-0 pos-relative mb-40 zindex-1",
            },
            [
              _c("orders-list", {
                attrs: {
                  orders: _vm.orders,
                  "orders-filter": _vm.ordersFilter,
                  current: _vm.order,
                },
                on: { "set-current": _vm.setCurrent },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showOrder,
              expression: "showOrder",
            },
          ],
          staticClass: "rightSide--orderPage h-100 overflow-y",
        },
        [
          _c("order-page", {
            attrs: {
              order: _vm.order,
              "show-reorder": _vm.showReorder,
              loading: _vm.loading,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }